/* eslint-disable */
import React from "react";
import { useHistory } from "react-router-dom";
// import { FaChartBar, FaUsers, FaCog } from "react-icons/fa";
// import {
//     FaTools, 
//     FaDatabase,
//     FaCar,
//     FaIndustry,
//     FaCogs,
//     FaHeadset,
//     FaMoneyCheckAlt,
//   } from "react-icons/fa";
import "./NavigationCard.css";

  
  // const cardData = [
  //   {
  //     id: 1,
  //     title: "Purchase",
  //     icon: <FaTools />, // Automotive parts procurement
  //     path: "/Procure-To-Pay/Purchase",
  //   },
  //   {
  //     id: 2,
  //     title: "MDM",
  //     icon: <FaDatabase />, // Master Data Management
  //     path: "/Procure-To-Pay/MDM",
  //   },
  //   {
  //     id: 3,
  //     title: "Accounts Payables",
  //     icon: <FaMoneyCheckAlt />, // Financial transaction / payments
  //     path: "/Procure-To-Pay/Account-Payable",
  //   },
  //   {
  //     id: 4,
  //     title: "CRDO",
  //     icon: <FaCogs />, // Engineering / R&D / automotive components
  //     path: "/Procure-To-Pay/CRDO",
  //   },
  //   {
  //     id: 5,
  //     title: "VMO and Contact Center",
  //     icon: <FaHeadset />, // Vendor support / service desk
  //     path: "/Procure-To-Pay/VMO-Contact-center",
  //   },
  //   {
  //     id: 6,
  //     title: "Vendor Payment Scheme",
  //     icon: <FaHandshake />, // Vendor partnership / agreements
  //     path: "/Procure-To-Pay/Vendor-Payment-Scheme",
  //   },
  // ];

const NavigateCard = ({cardData, detailState}) => {
  const history = useHistory();
  let cards = cardData;
  let detailStatecards = detailState;
  return (
    <div className="nav-card-container">
      {cards.map((card) => (
        <div
          key={card.id}
          className="nav-card"
          onClick={() => history.push(card.path,detailStatecards)}
        >
          <div className="icon">{card.icon}</div>
          <h3>{card.title}</h3>
          <p>{card.description}</p>
          <button className="nav-btn">Go</button>
        </div>
      ))}
    </div>
  );
};

export default NavigateCard;